import { RouteRecordRaw } from 'vue-router'

import { SHOW_TIME_ROUTE_NAMES } from '@/modules/showtime/constants/ShowTimeRouteNames'

import { UserGroup } from '@generated/types'

export const showTimeRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/showtimes',
    name: 'showtimes',
    redirect: { name: SHOW_TIME_ROUTE_NAMES.LIST },
  },
  {
    path: '/venue/show-time',
    component: () => import('@/modules/showtime/layouts/ShowTimeLayout.vue'),
    props: route => {
      const showTimeId = route.params.showTimeId
      if (!showTimeId) return { showTimeId: undefined }
      return { showTimeId: isNaN(Number(showTimeId)) ? showTimeId : Number(showTimeId) }
    },
    name: SHOW_TIME_ROUTE_NAMES.LIST,
    meta: { requiresAuth: UserGroup.MANAGERS, pageTitle: 'Show Times', usesCustomNavbar: true },
    children: [
      {
        path: ':showTimeId/edit',
        name: SHOW_TIME_ROUTE_NAMES.EDIT,
        component: () => import('@/modules/showtime/pages/ShowTimeEdit.vue'),
        props: route => {
          const showTimeId = route.params.showTimeId
          return { showTimeId: isNaN(Number(showTimeId)) ? showTimeId : Number(showTimeId) }
        },
        meta: {
          requiresAuth: UserGroup.MANAGERS,
          pageTitle: 'Show Time Edit',
        },
      },
    ],
  },
]
